import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65e9d388"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-text": "数据涉及到大量的查询计算过程，请耐心等待......",
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = { style: {"height":"50px","overflow-y":"hidden","line-height":"50px","font-size":"14px","font-weight":"900","margin-top":"-10px"} }
const _hoisted_3 = {
  key: 0,
  style: {"float":"left","color":"#00a9fc","width":"50px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","text-align":"center","color":"red","width":"calc(100% - 210px)"} }, null, -1))
const _hoisted_5 = {
  key: 3,
  style: {"float":"right"}
}
const _hoisted_6 = { style: {"width":"100%","overflow":"hidden"} }
const _hoisted_7 = { style: {"clear":"both"} }
const _hoisted_8 = { class: "el-alert__content" }
const _hoisted_9 = { class: "el-alert__title" }
const _hoisted_10 = { class: "el-alert__content" }
const _hoisted_11 = { class: "el-alert__title" }
const _hoisted_12 = { class: "el-alert__content" }
const _hoisted_13 = { class: "el-alert__title" }
const _hoisted_14 = { class: "el-alert__content" }
const _hoisted_15 = { class: "el-alert__title" }
const _hoisted_16 = { class: "el-alert__content" }
const _hoisted_17 = { class: "el-alert__title" }
const _hoisted_18 = { class: "el-alert__content" }
const _hoisted_19 = { class: "el-alert__title" }
const _hoisted_20 = { style: {"font-weight":"900","font-size":"14px"} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "（该子目录信息仅按业务周期统计）", -1))
const _hoisted_25 = { key: 3 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "（该子目录信息仅按业务周期统计）", -1))
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = {
  key: 6,
  style: {"margin-left":"20px"}
}
const _hoisted_30 = {
  key: 9,
  class: "count-search"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  ref: "divGrossProfitChart",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { style: {"margin-top":"10px","width":"100%"} }
const _hoisted_35 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 币制 ", -1))
const _hoisted_37 = { style: {"float":"left","width":"150px"} }
const _hoisted_38 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 金额 ", -1))
const _hoisted_40 = { style: {"float":"left","width":"150px"} }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  style: {"font-weight":"900","float":"left","width":"70px"}
}
const _hoisted_43 = {
  key: 1,
  style: {"float":"left","width":"150px"}
}
const _hoisted_44 = {
  key: 2,
  style: {"font-weight":"900","float":"left","width":"70px"}
}
const _hoisted_45 = {
  key: 3,
  style: {"float":"left","width":"150px"}
}
const _hoisted_46 = { style: {"padding-top":"10px","font-weight":"900","line-height":"36px"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_49 = {
  key: 2,
  style: {"width":"100%","text-align":"center","line-height":"40px"}
}
const _hoisted_50 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { style: {"margin-top":"15px"} }
const _hoisted_53 = { style: {"margin-top":"10px","width":"100%"} }
const _hoisted_54 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 币制 ", -1))
const _hoisted_56 = { style: {"float":"left","width":"150px"} }
const _hoisted_57 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 总金额 ", -1))
const _hoisted_59 = { style: {"float":"left","width":"150px"} }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 已开票 ", -1))
const _hoisted_63 = { style: {"float":"left","width":"150px"} }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 未开票 ", -1))
const _hoisted_67 = { style: {"float":"left","width":"150px"} }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 已核销 ", -1))
const _hoisted_71 = { style: {"float":"left","width":"150px"} }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 逾期 ", -1))
const _hoisted_74 = { style: {"float":"left","width":"150px"} }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 坏账 ", -1))
const _hoisted_77 = { style: {"float":"left","width":"150px"} }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { style: {"clear":"both","font-size":"12px","line-height":"30px"} }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"70px"} }, " 未核销 ", -1))
const _hoisted_81 = { style: {"float":"left","width":"150px"} }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","float":"left","width":"50px","margin-left":"60px"} }, " 逾期 ", -1))
const _hoisted_84 = { style: {"float":"left","width":"150px"} }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = {
  key: 1,
  style: {"width":"100%","text-align":"center","line-height":"40px"}
}
const _hoisted_87 = {
  key: 2,
  style: {"margin-top":"10px"}
}
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收合计：", -1))
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = {
  key: 2,
  style: {"padding-left":"10px"}
}
const _hoisted_94 = { key: 3 }
const _hoisted_95 = { key: 4 }
const _hoisted_96 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已收合计：", -1))
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "成本合计：", -1))
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = {
  key: 2,
  style: {"padding-left":"10px"}
}
const _hoisted_105 = { key: 3 }
const _hoisted_106 = { key: 4 }
const _hoisted_107 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结算价合计：", -1))
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "利息合计：", -1))
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结算利润合计：", -1))
const _hoisted_117 = { key: 0 }
const _hoisted_118 = { key: 1 }
const _hoisted_119 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应发合计：", -1))
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "实发合计：", -1))
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { style: {"clear":"both","padding-top":"5px"} }
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { style: {"float":"left"} }
const _hoisted_130 = { key: 0 }
const _hoisted_131 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_132 = { key: 1 }
const _hoisted_133 = ["onClick"]
const _hoisted_134 = { key: 2 }
const _hoisted_135 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_136 = { key: 3 }
const _hoisted_137 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_138 = { key: 4 }
const _hoisted_139 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_140 = { key: 5 }
const _hoisted_141 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_142 = { key: 6 }
const _hoisted_143 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_144 = { key: 7 }
const _hoisted_145 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_146 = { key: 8 }
const _hoisted_147 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_148 = { key: 9 }
const _hoisted_149 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_150 = { key: 10 }
const _hoisted_151 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_152 = { key: 11 }
const _hoisted_153 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_154 = { key: 12 }
const _hoisted_155 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_156 = { key: 13 }
const _hoisted_157 = ["onClick"]
const _hoisted_158 = {
  key: 3,
  style: {"margin-top":"10px"}
}
const _hoisted_159 = { key: 0 }
const _hoisted_160 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收合计：", -1))
const _hoisted_162 = { key: 0 }
const _hoisted_163 = { key: 1 }
const _hoisted_164 = {
  key: 2,
  style: {"padding-left":"10px"}
}
const _hoisted_165 = { key: 3 }
const _hoisted_166 = { key: 4 }
const _hoisted_167 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已收合计：", -1))
const _hoisted_169 = { key: 0 }
const _hoisted_170 = { key: 1 }
const _hoisted_171 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "成本合计：", -1))
const _hoisted_173 = { key: 0 }
const _hoisted_174 = { key: 1 }
const _hoisted_175 = {
  key: 2,
  style: {"padding-left":"10px"}
}
const _hoisted_176 = { key: 3 }
const _hoisted_177 = { key: 4 }
const _hoisted_178 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结算价合计：", -1))
const _hoisted_180 = { key: 0 }
const _hoisted_181 = { key: 1 }
const _hoisted_182 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "利息合计：", -1))
const _hoisted_184 = { key: 0 }
const _hoisted_185 = { key: 1 }
const _hoisted_186 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "结算利润合计：", -1))
const _hoisted_188 = { key: 0 }
const _hoisted_189 = { key: 1 }
const _hoisted_190 = { style: {"clear":"both","padding-top":"5px"} }
const _hoisted_191 = { key: 0 }
const _hoisted_192 = { style: {"float":"left"} }
const _hoisted_193 = { key: 0 }
const _hoisted_194 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_195 = { key: 1 }
const _hoisted_196 = ["onClick"]
const _hoisted_197 = { key: 2 }
const _hoisted_198 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_199 = { key: 3 }
const _hoisted_200 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_201 = { key: 4 }
const _hoisted_202 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_203 = { key: 5 }
const _hoisted_204 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_205 = { key: 6 }
const _hoisted_206 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_207 = { key: 7 }
const _hoisted_208 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_209 = { key: 8 }
const _hoisted_210 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_211 = { key: 9 }
const _hoisted_212 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_213 = { key: 10 }
const _hoisted_214 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_215 = { key: 11 }
const _hoisted_216 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_217 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_218 = {
  ref: "detailFormPie",
  class: "count",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_219 = { style: {"clear":"both","margin-top":"-20px"} }
const _hoisted_220 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_221 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_222 = { key: 0 }
const _hoisted_223 = { key: 1 }
const _hoisted_224 = { key: 0 }
const _hoisted_225 = ["onClick"]
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 毛利润明细 ", -1))
const _hoisted_228 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_229 = { style: {"width":"100%"} }
const _hoisted_230 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应收合计：", -1))
const _hoisted_232 = { key: 0 }
const _hoisted_233 = { key: 1 }
const _hoisted_234 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应付合计：", -1))
const _hoisted_236 = { key: 0 }
const _hoisted_237 = { key: 1 }
const _hoisted_238 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "毛利合计：", -1))
const _hoisted_240 = { key: 0 }
const _hoisted_241 = { key: 1 }
const _hoisted_242 = { style: {"float":"left","width":"50%","line-height":"26px","font-weight":"900","font-size":"13px"} }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "综合毛利率：", -1))
const _hoisted_244 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_245 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_246 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_247 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_248 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_249 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_250 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_251 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_252 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_253 = ["onClick"]
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 核销记录 ", -1))
const _hoisted_256 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_257 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_258 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_259 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_260 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_261 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_262 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_263 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_264 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_265 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_266 = {
  key: 1,
  style: {"height":"30px","line-height":"30px"}
}
const _hoisted_267 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_268 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_miezz_month_choose = _resolveComponent("miezz-month-choose")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.FinancialManagement_StatisticalAnalysis_Overview == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 总览 "))
        : _createCommentVNode("", true),
      (_ctx.FinancialManagement_StatisticalAnalysis_SalespersonRelated == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeChannel('1'))),
            style: {"float":"left","cursor":"pointer","width":"90px"}
          }, " 业务员相关 "))
        : _createCommentVNode("", true),
      (_ctx.FinancialManagement_StatisticalAnalysis_CustomerRelated == true)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeChannel('2'))),
            style: {"float":"left","cursor":"pointer","width":"70px"}
          }, " 客户相关 "))
        : _createCommentVNode("", true),
      _hoisted_4,
      (_ctx.type!='2'&&_ctx.type!='5')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isFinancialCycle==false)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  style: {"cursor":"pointer"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTime()))
                }, "切换至财务周期"))
              : _createCommentVNode("", true),
            (_ctx.isFinancialCycle==true)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  style: {"cursor":"pointer"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTime()))
                }, "切换至业务周期"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isLeft==false)
        ? (_openBlock(), _createBlock(_component_el_card, {
            key: 0,
            class: "left"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.FinancialManagement_StatisticalAnalysis_Overview_CollecionProgress==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '0' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeType('0')))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 收款进度 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_Overview_PaymentProgress==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '1' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeType('1')))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 付款进度 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_Overview_GrossProfit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '3' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeType('3')))
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 毛利润 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_Overview_ActualProfit==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '4' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChangeType('4')))
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 实际利润 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_Overview_SalespersonPerformance==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '2' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeType('2')))
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 业务员绩效 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.FinancialManagement_StatisticalAnalysis_Overview_CustomerPerformance==true)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: "el-alert el-alert--info is-dark",
                      style: _normalizeStyle(_ctx.type == '5' ? 'background-color: #00a9fc;color:#fff;' : ''),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeType('5')))
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Document)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 客户绩效 ")
                        ])
                      ])
                    ], 4))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLeft==true?'middle':'isMiddle'),
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isLeft = !_ctx.isLeft))
      }, [
        (_ctx.isLeft == true)
          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isLeft == false)
          ? (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeft)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.isLeft==false?'right':'isRight')
      }, [
        _createVNode(_component_miezz_month_choose, {
          modelValue: _ctx.month,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.month) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              (_ctx.type == '0' || _ctx.type == '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 收款进度 "))
                : (_ctx.type == '1')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "付款进度"))
                  : (_ctx.type == '2')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        _createTextVNode(" 业务员绩效 "),
                        _hoisted_24
                      ]))
                    : (_ctx.type == '5')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                          _createTextVNode(" 客户绩效 "),
                          _hoisted_26
                        ]))
                      : (_ctx.type == '3')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, " 毛利润 "))
                        : (_ctx.type == '4')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, "实际利润"))
                          : _createCommentVNode("", true),
              (_ctx.type == '3' && _ctx.result.Rate!=null && _ctx.result.Rate!=undefined && _ctx.result.Rate!='')
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, " 参考汇率 " + _toDisplayString(_ctx.result.Rate), 1))
                : _createCommentVNode("", true),
              (_ctx.type == '3')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 7,
                    style: {"color":"#f6a46d","cursor":"pointer","float":"right"},
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onGrossProfitDetail()))
                  }, " 查看明细 "))
                : _createCommentVNode("", true),
              ((_ctx.type == '0' || _ctx.type == '' || _ctx.type=='1') && _ctx.isFinancialCycle!=true)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 8,
                    style: {"color":"#f6a46d","cursor":"pointer","margin-left":"10px"},
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onNoBill()))
                  }, " 委托书（无账单）票数：" + _toDisplayString(_ctx.result.PoolCount), 1))
                : _createCommentVNode("", true),
              (_ctx.type=='2'||_ctx.type=='5')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createVNode(_component_miezz_input, {
                      modelValue: _ctx.searchForm.CustomerName,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchForm.CustomerName) = $event)),
                      placeholder: _ctx.type=='2'?'请填写业务员关键词':'请填写客户名称关键词'
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode(_component_miezz_button, {
                      model: _ctx.btnSearch,
                      onHandleClick: _ctx.onStat
                    }, null, 8, ["model", "onHandleClick"]),
                    _createVNode(_component_miezz_button, {
                      model: _ctx.btnSearchReset,
                      onHandleClick: _ctx.clearSearch
                    }, null, 8, ["model", "onHandleClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.type=='3' || _ctx.type=='4')
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_ctx.type=='3' && _ctx.isGrossProfitChart==true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, null, 512))
                    : _createCommentVNode("", true),
                  (_ctx.result.Profit != _ctx.nul && _ctx.result.Profit.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.Profit, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"clear":"both","margin-top":"10px","border-bottom":"1px solid #eee","padding-bottom":"50px"},
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("div", _hoisted_37, _toDisplayString(p.CurrencySystemCode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formatNumber(p.Profit)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","width":"150px"},
                                  onClick: ($event: any) => (_ctx.onDetail(7,p.CurrencySystemId,p.CurrencySystemCode,'毛利润'))
                                }, " 查看组成 ", 8, _hoisted_41),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, " 应收税额： "))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.formatNumber(p.CollectionTaxAmount)), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, " 应付税额： "))
                                  : _createCommentVNode("", true),
                                (_ctx.currencySystem?.ShowTaxRate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.formatNumber(p.PaymentTaxAmount)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_46, [
                          _createTextVNode(" 合计：CNY " + _toDisplayString(_ctx.formatNumber(_ctx.result.Total)) + " ", 1),
                          _createElementVNode("span", {
                            style: {"color":"#f6a46d","cursor":"pointer","margin-left":"20px"},
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSumLink()))
                          }, " 查看明细 "),
                          _hoisted_47,
                          (_ctx.type=='3')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, "已核销利润（已核销应收金额-已核销应付金额，折算为CNY得出）：CNY " + _toDisplayString(_ctx.formatNumber(_ctx.result.RealityProfit)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_49, " 暂无数据 "))
                ]))
              : _createCommentVNode("", true),
            (_ctx.type=='0' || _ctx.type=='1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (_ctx.result.Item != _ctx.nul && _ctx.result.Item.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.Item, (p, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: {"clear":"both","margin-top":"10px","border-bottom":"1px solid #eee","padding-bottom":"50px"},
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_el_progress, {
                                "text-inside": true,
                                "stroke-width": 22,
                                percentage: p.Progress
                              }, null, 8, ["percentage"])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, _toDisplayString(p.CurrencySystemCode), 1)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.formatNumber(p.Total)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (_ctx.onDetail(0,p.CurrencySystemId,p.CurrencySystemCode,'总金额'))
                                }, " 查看组成 ", 8, _hoisted_60)
                              ]),
                              _createElementVNode("div", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.formatNumber(p.Invoice)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      1,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '已开票'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_64)
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _hoisted_66,
                                _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatNumber(p.NoInvoice)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      2,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '未开票'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_68)
                              ]),
                              _createElementVNode("div", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.formatNumber(p.Settlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      3,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '已核销'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_72),
                                _hoisted_73,
                                _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.formatNumber(p.SettlementOverdue)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      5,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '已核销逾期'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_75),
                                _hoisted_76,
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.formatNumber(p.BadSettlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","width":"150px"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      8,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '坏账'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_78),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left","font-size":"14px"},
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSettlement()))
                                }, " 核销记录 ")
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.formatNumber(p.NoSettlement)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      4,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '未核销'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_82),
                                _hoisted_83,
                                _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.formatNumber(p.NoSettlementOverdue)), 1),
                                _createElementVNode("div", {
                                  style: {"color":"#f6a46d","cursor":"pointer","float":"left"},
                                  onClick: ($event: any) => (
                    _ctx.onDetail(
                      6,
                      p.CurrencySystemId,
                      p.CurrencySystemCode,
                      '未核销逾期'
                    )
                  )
                                }, " 查看组成 ", 8, _hoisted_85)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_86, " 暂无数据 "))
                ]))
              : (_ctx.type=='2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    (_ctx.items != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _hoisted_90,
                            (_ctx.items.Data.CollectionString!=null && _ctx.items.Data.CollectionString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_ctx.items.Data.CollectionString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_92, "CNY 0")),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_93, "应收税额："))
                              : _createCommentVNode("", true),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.items.Data.CollectionTaxAmountString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_95, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _hoisted_97,
                            (_ctx.items.Data.CollectionedString!=null && _ctx.items.Data.CollectionedString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(_ctx.items.Data.CollectionedString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_99, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_100, [
                            _hoisted_101,
                            (_ctx.items.Data.CostString!=null && _ctx.items.Data.CostString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.items.Data.CostString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_103, "CNY 0")),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_104, "应付税额："))
                              : _createCommentVNode("", true),
                            (_ctx.currencySystem?.ShowTaxRate)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(_ctx.items.Data.CostTaxAmountString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_106, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_107, [
                            _hoisted_108,
                            (_ctx.items.Data.SettlementString!=null && _ctx.items.Data.SettlementString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_109, _toDisplayString(_ctx.items.Data.SettlementString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_110, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_111, [
                            _hoisted_112,
                            (_ctx.items.Data.InterestString!=null && _ctx.items.Data.InterestString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(_ctx.items.Data.InterestString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_114, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_115, [
                            _hoisted_116,
                            (_ctx.items.Data.SumSalerProfit!=null && _ctx.items.Data.SumSalerProfit!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(_ctx.items.Data.SumSalerProfit), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_118, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_119, [
                            _hoisted_120,
                            (_ctx.items.Data.PaymentString!=null && _ctx.items.Data.PaymentString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.items.Data.PaymentString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_122, "CNY 0"))
                          ]),
                          _createElementVNode("div", _hoisted_123, [
                            _hoisted_124,
                            (_ctx.items.Data.ActualString!=null && _ctx.items.Data.ActualString!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_ctx.items.Data.ActualString), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_126, "CNY 0"))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_127, [
                      _createVNode(_component_miezz_page_list, {
                        modelValue: _ctx.items,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.items) = $event))
                      }, {
                        "column-header": _withCtx(({ model }) => [
                          (model.Prop == 'PaymentString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, _toDisplayString(model.Label), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        column: _withCtx(({ model,row }) => [
                          (model.Prop == 'BookingNo')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.isString(row.BookingNo)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ClientCompanyName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.onClientCompany(row)),
                                  style: {"color":"#fe995b","cursor":"pointer","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(_ctx.isString(row.ClientCompanyName)), 9, _hoisted_133)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SalerName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.isString(row.SalerName)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CollectionString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.isString(row.CollectionString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CollectionTaxAmountString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.isString(row.CollectionTaxAmountString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CollectionedString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.isString(row.CollectionedString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CostString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.isString(row.CostString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'CostTaxAmountString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                _createElementVNode("div", _hoisted_145, _toDisplayString(_ctx.isString(row.CostTaxAmountString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SettlementString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                _createElementVNode("div", _hoisted_147, _toDisplayString(_ctx.isString(row.SettlementString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'InterestString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                _createElementVNode("div", _hoisted_149, _toDisplayString(_ctx.isString(row.InterestString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'SumSalerProfit')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                _createElementVNode("div", _hoisted_151, _toDisplayString(_ctx.isString(row.SumSalerProfit)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'PaymentString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                                _createElementVNode("div", _hoisted_153, _toDisplayString(_ctx.isString(row.PaymentString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'ActualString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                _createElementVNode("div", _hoisted_155, _toDisplayString(_ctx.isString(row.ActualString)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (model.Prop == 'OperationString')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (_ctx.onSaler(row)),
                                  style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, " 查看详情 ", 8, _hoisted_157)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]))
                : (_ctx.type=='5')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                      (_ctx.items != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                            _createElementVNode("div", _hoisted_160, [
                              _hoisted_161,
                              (_ctx.items.Data.CollectionString!=null && _ctx.items.Data.CollectionString!='')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_162, _toDisplayString(_ctx.items.Data.CollectionString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_163, "CNY 0")),
                              (_ctx.currencySystem?.ShowTaxRate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_164, "应收税额："))
                                : _createCommentVNode("", true),
                              (_ctx.currencySystem?.ShowTaxRate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_165, _toDisplayString(_ctx.items.Data.CollectionTaxAmountString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_166, "CNY 0"))
                            ]),
                            _createElementVNode("div", _hoisted_167, [
                              _hoisted_168,
                              (_ctx.items.Data.CollectionedString!=null && _ctx.items.Data.CollectionedString!='')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_169, _toDisplayString(_ctx.items.Data.CollectionedString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_170, "CNY 0"))
                            ]),
                            _createElementVNode("div", _hoisted_171, [
                              _hoisted_172,
                              (_ctx.items.Data.CostString!=null && _ctx.items.Data.CostString!='')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_173, _toDisplayString(_ctx.items.Data.CostString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_174, "CNY 0")),
                              (_ctx.currencySystem?.ShowTaxRate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_175, "应付税额："))
                                : _createCommentVNode("", true),
                              (_ctx.currencySystem?.ShowTaxRate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_176, _toDisplayString(_ctx.items.Data.CostTaxAmountString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_177, "CNY 0"))
                            ]),
                            _createElementVNode("div", _hoisted_178, [
                              _hoisted_179,
                              (_ctx.items.Data.SettlementString!=null && _ctx.items.Data.SettlementString!='')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_180, _toDisplayString(_ctx.items.Data.SettlementString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_181, "CNY 0"))
                            ]),
                            _createElementVNode("div", _hoisted_182, [
                              _hoisted_183,
                              (_ctx.items.Data.InterestString!=null && _ctx.items.Data.InterestString!='')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_184, _toDisplayString(_ctx.items.Data.InterestString), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_185, "CNY 0"))
                            ]),
                            _createElementVNode("div", _hoisted_186, [
                              _hoisted_187,
                              (_ctx.items.Data.SumSalerProfit!=null && _ctx.items.Data.SumSalerProfit!='')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_188, _toDisplayString(_ctx.items.Data.SumSalerProfit), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_189, "CNY 0"))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_190, [
                        _createVNode(_component_miezz_page_list, {
                          modelValue: _ctx.items,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.items) = $event))
                        }, {
                          "column-header": _withCtx(({ model }) => [
                            (model.Prop == 'PaymentString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                  _createElementVNode("div", _hoisted_192, _toDisplayString(model.Label), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          column: _withCtx(({ model,row }) => [
                            (model.Prop == 'BookingNo')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                  _createElementVNode("div", _hoisted_194, _toDisplayString(_ctx.isString(row.BookingNo)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'ClientCompanyName')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                  _createElementVNode("div", {
                                    onClick: ($event: any) => (_ctx.onClientCompany(row)),
                                    style: {"color":"#fe995b","cursor":"pointer","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                  }, _toDisplayString(_ctx.isString(row.ClientCompanyName)), 9, _hoisted_196)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'SalerName')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                  _createElementVNode("div", _hoisted_198, _toDisplayString(_ctx.isString(row.SalerName)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'CollectionString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                  _createElementVNode("div", _hoisted_200, _toDisplayString(_ctx.isString(row.CollectionString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'CollectionTaxAmountString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                  _createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.isString(row.CollectionTaxAmountString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'CollectionedString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                  _createElementVNode("div", _hoisted_204, _toDisplayString(_ctx.isString(row.CollectionedString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'CostString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                  _createElementVNode("div", _hoisted_206, _toDisplayString(_ctx.isString(row.CostString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'CostTaxAmountString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                  _createElementVNode("div", _hoisted_208, _toDisplayString(_ctx.isString(row.CostTaxAmountString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'SettlementString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                                  _createElementVNode("div", _hoisted_210, _toDisplayString(_ctx.isString(row.SettlementString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'InterestString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                  _createElementVNode("div", _hoisted_212, _toDisplayString(_ctx.isString(row.InterestString)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'SumSalerProfit')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                                  _createElementVNode("div", _hoisted_214, _toDisplayString(_ctx.isString(row.SumSalerProfit)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (model.Prop == 'OperationString')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_215))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.detailForm.Visible,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.detailForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"60%"},
      top: "10px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_216, _toDisplayString(_ctx.detailForm.Title), 1),
        _createElementVNode("div", _hoisted_217, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_218, null, 512),
        _createElementVNode("div", _hoisted_219, [
          _createVNode(_component_el_table, {
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.detailForm.Details,
            ref: "$billTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Name",
                label: _ctx.CompositionType==7?'委托人':'对账对象',
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_220, _toDisplayString(_ctx.isString(scope.row.Name)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Value",
                label: "金额（元）",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_221, [
                    (scope.row.Value==0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_222, "0"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_223, [
                          _createTextVNode(_toDisplayString(_ctx.isString(_ctx.formatNumber(scope.row.Value))) + " ", 1),
                          (scope.row.StatPrice!=undefined && scope.row.StatPrice!=null && scope.row.StatPrice!='')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_224, "( " + _toDisplayString(_ctx.formatNumber(scope.row.StatPrice)) + ")", 1))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "操作",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onClientDetail(scope.row)),
                    style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看账单 ", 8, _hoisted_225)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_226,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.detailBottomButtons,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.detailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.grossProfitDetailForm.Visible,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.grossProfitDetailForm.Visible) = $event)),
      "show-close": false,
      style: {"width":"80%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_227,
        _createElementVNode("div", _hoisted_228, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_229, [
          _createElementVNode("div", _hoisted_230, [
            _hoisted_231,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.CollectionDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_232, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.CollectionDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_233, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_234, [
            _hoisted_235,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.PaymentDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_236, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.PaymentDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_237, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_238, [
            _hoisted_239,
            (_ctx.result.GrossProfit.GrossProfitDetail!=null && _ctx.result.GrossProfit.GrossProfitDetail.GrossProfitDetail!='')
              ? (_openBlock(), _createElementBlock("span", _hoisted_240, _toDisplayString(_ctx.result.GrossProfit.GrossProfitDetail.GrossProfitDetail), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_241, "CNY 0"))
          ]),
          _createElementVNode("div", _hoisted_242, [
            _hoisted_243,
            _createElementVNode("span", null, _toDisplayString(_ctx.isString(_ctx.result.GrossProfit.GrossProfitDetail.GrossPointDetail)), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            stripe: "",
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.result.GrossProfit.GrossProfitDetail.Pools,
            ref: "$grossProfitDetailTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.BookingNo",
                label: "BookingNo",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_244, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.ClientCompany",
                label: "委托公司",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_245, _toDisplayString(_ctx.isString(scope.row.ClientCompany)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.CustomerServiceLabel",
                label: "客服",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_246, _toDisplayString(_ctx.isString(scope.row.CustomerServiceLabel)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.SalerName",
                label: "业务员",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_247, _toDisplayString(_ctx.isString(scope.row.SalerName)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "应收合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_248, _toDisplayString(_ctx.isString(scope.row.Collection)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "应收坏账",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_249, _toDisplayString(_ctx.isString(scope.row.BadCollectionSettlement)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Payment",
                label: "应付合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_250, _toDisplayString(_ctx.isString(scope.row.Payment)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Payment",
                label: "应付坏账",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_251, _toDisplayString(_ctx.isString(scope.row.BadPaymentSettlement)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Profit",
                label: "毛利润合计",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    style: _normalizeStyle([scope.row.IsProfit==true?'color:red;':'', {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}])
                  }, _toDisplayString(_ctx.isString(scope.row.Profit)), 5)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.GrossPointString",
                label: "单票毛利率",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_252, _toDisplayString(_ctx.isString(scope.row.GrossPointString)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Collection",
                label: "操作",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onPool(scope.row)),
                    style: {"cursor":"pointer","color":"#fe995b","width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                  }, " 查看账单 ", 8, _hoisted_253)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_254,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.grossProfitDetailBottomButtons,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.grossProfitDetailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickGrossProfitDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.settlementVisible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.settlementVisible) = $event)),
      "show-close": false,
      style: {"width":"80%"},
      top: "0px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_255,
        _createElementVNode("div", _hoisted_256, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_table, {
            stripe: "",
            border: "",
            "tree-props": {children: 'Child', hasChildren: 'hasChildren'},
            "row-key": "Id",
            "default-expand-all": false,
            data: _ctx.result.Settlements,
            ref: "$settlementTable",
            style: {"width":"100%","margin-top":"15px"},
            "header-cell-style": { 'text-align': 'left' },
            "cell-style": { 'text-align': 'left' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "scope.row.BookingNo",
                label: "BookingNo",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_257, _toDisplayString(_ctx.isString(scope.row.BookingNo)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.OrderCode",
                label: "订单编号",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_258, _toDisplayString(_ctx.isString(scope.row.OrderCode)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Price",
                label: "核销金额",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_259, _toDisplayString(_ctx.isString(scope.row.CurrencySystemCode)) + _toDisplayString(_ctx.isString(scope.row.Price)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Rate",
                label: "汇率",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_260, _toDisplayString(_ctx.isString(scope.row.Rate)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_261, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.SettlementDate",
                label: "核销时间",
                "show-overflow-tooltip": true,
                width: "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_262, _toDisplayString(_ctx.isString(scope.row.SettlementDate)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.CollectionTitle",
                label: "收款方",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_263, _toDisplayString(_ctx.isString(scope.row.CollectionTitle)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_264, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.PaymentTitle",
                label: "付款方",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  (scope.row.Mode != '坏账核销')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_265, _toDisplayString(_ctx.isString(scope.row.PaymentTitle)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_266, " — "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Mode",
                label: "核销方式",
                "show-overflow-tooltip": true,
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_267, _toDisplayString(_ctx.isString(scope.row.Mode)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "scope.row.Remark",
                label: "备注",
                "show-overflow-tooltip": true
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_268, _toDisplayString(_ctx.isString(scope.row.Remark)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _hoisted_269,
        _createVNode(_component_miezz_button_bar, {
          modelValue: _ctx.settlementDetailBottomButtons,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.settlementDetailBottomButtons) = $event)),
          isBackground: true,
          onHandleClick: _ctx.handleClickSettlementDetail
        }, null, 8, ["modelValue", "onHandleClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}